import axios from "axios";
import { toast } from "react-toastify";
import { oneKlicks } from "../SDK/oneclick";
import { oneKlickstest } from "../SDK/test";
import CryptoJS from "crypto-js";
import { debugLog } from "../utils/debug";
import Getlocation from "../Uitiles/Getlocation";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import ImageShow from "../Uitiles/ImageShow";
import { getSettings } from "./settingsService";

const apiUrl = process.env.REACT_APP_API_URL;
const apiUrllocal = process.env.REACT_APP_API_URL_LOCAL;

const meddylistApiUrl = process.env.REACT_APP_API_URL_LOCAL || 'http://localhost:3002/api/';

export const formatUrlString = (name) => {
    if (!name) return '';
    let formattedName = name.replace(/^dr[-_\s]+/i, '');
    formattedName = formattedName.replace(/\|/g, '').replace(/&amp;/g, 'and');
    formattedName = formattedName.replace(/\//g, '-');
    formattedName = formattedName.replace(/[.\s]+/g, '-');
    formattedName = formattedName.toLowerCase();
    formattedName = formattedName.replace(/-+/g, '-');
    formattedName = formattedName.replace(/^-+|-+$/g, '');
    return formattedName;
};

export const updateactivities = async ({ localid, name, description, type }) => {
    try {
        const user_location = await Getlocation();
        console.log("user_location :", user_location);
        const user_id = await getuserdata('id');
        const tableSchema = "";
        const tableName = "activities";
        const conditions = {};
        const data = {
            user_id: user_id || "",
            name: name,
            localid: localid,
            description: description,
            type: type,
            url: window.location.href,
            user_location: JSON.stringify(user_location)
        };
        // const response = await oneKlickstest.create(tableSchema, tableName, data, conditions);
        // if (response.success) {
        //     return response.data;
        // } else {
        //     return { success: false, error: response.error };
        // }
    } catch (error) {
        console.error("Error updating activities:", error);
        return { success: false, error: error.message };
    }
}

export const getCurrencySymbol = (currency) => {
    const currencyMap = {
        'USD': '$', 'EUR': '€', 'GBP': '£', 'INR': '₹',
        'JPY': '¥', 'AUD': 'A$', 'CAD': 'C$'
    };
    return currencyMap[currency] || '₹';
};

export const genareteInvoicePDF = async (invoiceId) => {
    try {
        // Fetch settings first
        const settings = await getSettings();

        // Fetch invoice data
        const tableSchema = "";
        const tableName = "invoices";
        const orderBy = "id DESC";
        const search = {};
        const pagination = {};
        const margedata = [
            {
                "target_table": "users",
                "target_column": "id",
                "target_value": "client",
                "target_label": "users"
            },
            {
                "target_table": "users_billing_details",
                "target_column": "user_id",
                "target_value": "client",
                "target_label": "users_billing_details"
            },
            {
                "target_table": "invoice_payments",
                "target_column": "invoice_id",
                "target_value": "id",
                "target_label": "invoice_payments"
            },
            {
                "target_table": "virtual_accounts",
                "target_column": "user_id",
                "target_value": "client",
                "target_label": "accounts"
            },
            {
                "target_table": "invoice_items",
                "target_column": "invoice_id",
                "target_value": "id",
                "target_label": "invoice_items",
                margedata: [
                    {
                        "target_table": "packages",
                        "target_column": "id",
                        "target_value": "packageId",
                        "target_label": "packages"
                    }
                ]
            }
        ];

        const conditions = {
            "id": invoiceId
        };

        console.log("conditions", conditions);
        const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
        console.log("invoice response getInvoice :", response);

        if (response.success && response.data.length > 0) {
            const invoice = response.data[0];
            const receiversData = response.data?.[0]?.accounts?.[0]?.receivers || [];
            console.log("receiversData", receiversData);

            let bankAccountDetails = {};
            if (typeof receiversData === 'string') {
                const parsedReceivers = JSON.parse(receiversData);
                bankAccountDetails = parsedReceivers?.[0] || {};
            } else {
                bankAccountDetails = receiversData?.[0] || {};
            }

            return htmlcode({ invoice, settings, bankAccountDetails });
        } else {
            throw new Error("Invoice not found");
        }
    } catch (err) {
        console.error("Failed to generate invoice PDF:", err);
        throw err;
    }
}

export const createWhatsappQRCode = async (phoneNumber) => {
    try {
        // Check if the API URL is configured
        if (!meddylistApiUrl) {
            throw new Error('API URL not configured. Please set REACT_APP_API_URL_LOCAL environment variable.');
        }

        // Validate phone number
        if (!phoneNumber || phoneNumber.trim() === '') {
            throw new Error('Phone number is required');
        }

        const userId = await getuserdata('id');
        if (!userId) {
            throw new Error('User not authenticated');
        }

        console.log('Making request to:', `${meddylistApiUrl}whatsapp/generate-qr`);
        console.log('Request payload:', { userId, sessionId: phoneNumber });

        const response = await axios.post(`${meddylistApiUrl}whatsapp/generate-qr`,
            {
                "userId": userId,
                "sessionId": phoneNumber
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                timeout: 30000 // 30 second timeout
            }
        );

        console.log('WhatsApp QR code response:', response.data);
        return response.data;
    } catch (err) {
        console.error("Failed to create WhatsApp QR code:", err);

        // Provide more specific error messages
        if (err.response) {
            // Server responded with error status
            console.error('Server error:', err.response.status, err.response.data);
            throw new Error(`Server error: ${err.response.status} - ${err.response.data?.message || 'Unknown error'}`);
        } else if (err.request) {
            // Request was made but no response received
            console.error('No response from server:', err.request);
            throw new Error('Unable to connect to server. Please check if the backend server is running.');
        } else {
            // Something else happened
            throw new Error(err.message || 'Unknown error occurred');
        }
    }
}

export const checkWhatsappQRCodeStatus = async (sessionId) => {
    try {
        // Check if the API URL is configured
        if (!meddylistApiUrl) {
            throw new Error('API URL not configured. Please set REACT_APP_API_URL_LOCAL environment variable.');
        }

        // Validate session ID
        if (!sessionId || sessionId.trim() === '') {
            throw new Error('Session ID is required');
        }

        console.log('Checking status for session:', sessionId);

        const response = await axios.get(`${meddylistApiUrl}whatsapp/status/${sessionId}`, {
            headers: {
                'Content-Type': 'application/json'
            },
            timeout: 10000 // 10 second timeout
        });

        console.log('WhatsApp status response:', response.data);
        return response.data;
    } catch (err) {
        console.error("Failed to check WhatsApp QR code status:", err);

        // Provide more specific error messages
        if (err.response) {
            console.error('Server error:', err.response.status, err.response.data);
            throw new Error(`Server error: ${err.response.status} - ${err.response.data?.message || 'Unknown error'}`);
        } else if (err.request) {
            console.error('No response from server:', err.request);
            throw new Error('Unable to connect to server. Please check if the backend server is running.');
        } else {
            throw new Error(err.message || 'Unknown error occurred');
        }
    }
}



const htmlcode = ({ invoice, settings, bankAccountDetails }) => {
    return (
        <div className="invoice-print-container" style={{
            display: 'flex',
            flexDirection: 'column',
            width: '210mm',
            minHeight: '297mm',
            margin: '0 auto',
            padding: '10mm 10mm 10mm 10mm',
            backgroundColor: 'white',
            fontFamily: 'Arial, sans-serif',
            fontSize: '12px',
            lineHeight: '1.4',
            color: '#333',
            boxShadow: '0 0 10px rgba(0,0,0,0.1)',
            paddingBottom: '15mm'
        }}>
            {invoice ? (
                <>
                    {/* Print Styles */}
                    <style>
                        {`
                @media print {
                  body * {
                    visibility: hidden;
                  }
                  .invoice-print-container, .invoice-print-container * {
                    visibility: visible;
                  }
                  .invoice-print-container {
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100% !important;
                    height: 100% !important;
                    margin: 0 !important;
                    padding: 10mm 10mm 15mm 10mm !important;
                    box-shadow: none !important;
                  }
                  .no-print {
                    display: none !important;
                  }
                }
                
                .invoice-header {
                  border-bottom: 2px solid #2980b9;
                  padding-bottom: 15px;
                  margin-bottom: 10px;
                }
                
                .invoice-title {
                  font-size: 15px;
                  font-weight: bold;
                  color: #ffffff;
                  margin: 0;
                }
                
                .invoice-info {
                  display: flex;
                  justify-content: space-between;
                  margin-bottom: 10px;
                }
                
                .company-details, .client-details {
                  flex: 1;
                }
                
                .invoice-table {
                  width: 100%;
                  border-collapse: collapse;
                  margin: 0 0;
                }
                
                .invoice-table th,
                .invoice-table td {
                  border: 1px solid #ddd;
                  padding: 8px;
                  text-align: left;
                }
                
                .invoice-table th {
                  background-color: #2980b9;
                  color: white;
                  font-weight: bold;
                }
                
                .invoice-table .text-right {
                  text-align: right;
                }
                
                .invoice-totals {
                  margin-top: 20px;
                  text-align: right;
                }
                
                .invoice-footer {
                  margin-top: 30px;
                  padding-top: 15px;
                  border-top: 1px solid #ddd;
                  text-align: center;
                  font-size: 11px;
                  color: #666;
                }
                
                .status-badge {
                  display: inline-block;
                  padding: 6px 16px;
                  border-radius: 20px;
                  font-size: 10px;
                  font-weight: bold;
                  text-transform: uppercase;
                  letter-spacing: 0.5px;
                  border: 2px solid transparent;
                  position: relative;
                  overflow: hidden;
                }
                
                .status-badge::before {
                  content: '';
                  position: absolute;
                  top: 0;
                  left: -100%;
                  width: 100%;
                  height: 100%;
                  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
                  transition: left 0.5s;
                }
                
                .status-badge:hover::before {
                  left: 100%;
                }
                
                /* Paid Status - Green with success icon */
                .status-paid { 
                  background: linear-gradient(135deg, #27ae60, #2ecc71);
                  color: white;
                  border-color: #27ae60;
                  box-shadow: 0 2px 8px rgba(39, 174, 96, 0.3);
                }
                
                .status-paid::after {
                  content: '✓';
                  margin-left: 4px;
                  font-weight: bold;
                }
                
                /* Pending Status - Orange with clock icon */
                .status-pending { 
                  background: linear-gradient(135deg, #f39c12, #e67e22);
                  color: white;
                  border-color: #f39c12;
                  box-shadow: 0 2px 8px rgba(243, 156, 18, 0.3);
                }
                
                .status-pending::after {
                  content: '⏰';
                  margin-left: 4px;
                }
                
                /* Overdue Status - Red with warning icon */
                .status-overdue { 
                  background: linear-gradient(135deg, #e74c3c, #c0392b);
                  color: white;
                  border-color: #e74c3c;
                  box-shadow: 0 2px 8px rgba(231, 76, 60, 0.3);
                  animation: pulse 2s infinite;
                }
                
                .status-overdue::after {
                  content: '⚠';
                  margin-left: 4px;
                  font-weight: bold;
                }
                
                /* Draft Status - Gray with edit icon */
                .status-draft { 
                  background: linear-gradient(135deg, #95a5a6, #7f8c8d);
                  color: white;
                  border-color: #95a5a6;
                  box-shadow: 0 2px 8px rgba(149, 165, 166, 0.3);
                }
  
                .status-partial_payment { 
                  background: linear-gradient(135deg, #3498db, #2980b9);
                  color: white;
                  border-color: #3498db;
                  box-shadow: 0 2px 8px rgba(52, 152, 219, 0.3);
                }
  
                .status-partial_payment::after {
                  content: '💰';
                  margin-left: 4px;
                }
  
                .status-draft::after {
                  content: '✏';
                  margin-left: 4px;
                }
                
                /* Partial Payment Status - Blue with info icon */
                .status-partial_pay { 
                  background: linear-gradient(135deg, #3498db, #2980b9);
                  color: white;
                  border-color: #3498db;
                  box-shadow: 0 2px 8px rgba(52, 152, 219, 0.3);
                }
                
                .status-partial_pay::after {
                  content: '💰';
                  margin-left: 4px;
                }
                
                /* Cancelled Status - Dark red with X icon */
                .status-cancelled { 
                  background: linear-gradient(135deg, #8e44ad, #9b59b6);
                  color: white;
                  border-color: #8e44ad;
                  box-shadow: 0 2px 8px rgba(142, 68, 173, 0.3);
                }
                
                .status-cancelled::after {
                  content: '✕';
                  margin-left: 4px;
                  font-weight: bold;
                }
                
                /* Default Status - Neutral gray */
                .status-default { 
                  background: linear-gradient(135deg, #34495e, #2c3e50);
                  color: white;
                  border-color: #34495e;
                  box-shadow: 0 2px 8px rgba(52, 73, 94, 0.3);
                }
                
                @keyframes pulse {
                  0% { transform: scale(1); }
                  50% { transform: scale(1.05); }
                  100% { transform: scale(1); }
                }
              `}
                    </style>

                    {/* Invoice Content */}
                    <div className="invoice-header">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div>
                                <img src={process.env.REACT_APP_API_BASE_LIVE_URL + settings.logo_url || ''} alt="Company Logo" style={{ height: '50px', marginLeft: '-8px' }} />
                                <h1 className="invoice-title">{settings.site_name || 'Company Name'}</h1>
                                <p style={{ margin: '5px 0', fontSize: '11px', color: '#ffffff' }}>
                                    {settings.contact_address || 'Company Address'}
                                </p>
                                <p style={{ margin: '5px 0', fontSize: '11px', color: '#ffffff' }}>
                                    Phone: {settings.contact_phone || 'N/A'} | Email: {settings.contact_email || 'N/A'}
                                </p>
                                <p style={{ margin: '5px 0', fontSize: '11px', color: '#ffffff' }}>
                                    TAX ID: {settings.tax_id || 'N/A'} | GSTIN: {settings.gstin || 'N/A'}
                                </p>
                            </div>
                            <div style={{ textAlign: 'right' }}>
                                <h2 style={{ margin: '0 0 10px 0', fontSize: '20px', color: '#2980b9' }}>INVOICE</h2>
                                <div style={{ fontSize: '11px', color: '#ffffff' }}>
                                    <p style={{ margin: '2px 0', color: '#ffffff' }}><strong style={{ color: '#ffffff' }}>Invoice #:</strong> {invoice.id}</p>
                                    <p style={{ margin: '2px 0', color: '#ffffff' }}><strong style={{ color: '#ffffff' }}>Date: </strong> {invoice.created_at ? new Date(invoice.created_at).toLocaleDateString() : ''}</p>
                                    <p style={{ margin: '2px 0', color: '#ffffff' }}><strong style={{ color: '#ffffff' }}>Due Date: </strong> {invoice.dueDate ? new Date(invoice.dueDate).toLocaleDateString() : ''}</p>
                                    <p style={{ margin: '10px 0 5px 0' }}>
                                        <span className={`status-badge status-${(invoice.status?.toLowerCase() || 'draft').replace(/\s+/g, '_')}`}>
                                            {invoice.status || 'Draft'}
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="invoice-info">
                        <div className="company-details">
                            <h4 style={{ margin: '0 0 10px 0', color: '#2980b9' }}>From:</h4>
                            <p style={{ margin: '2px 0' }}><strong>{settings.site_name || 'Company Name'}</strong></p>
                            <p style={{ margin: '2px 0', fontSize: '11px' }}>{settings.contact_address || 'Company Address'}</p>
                            <p style={{ margin: '2px 0', fontSize: '11px' }}>
                                Phone: {settings.contact_phone || 'N/A'} | Email: {settings.contact_email || 'N/A'}
                            </p>
                        </div>
                        <div className="client-details">
                            <h4 style={{ margin: '0 0 10px 0', color: '#2980b9' }}>Bill To:</h4>
                            <p style={{ margin: '2px 0' }}><strong>{invoice.users_billing_details?.[0]?.name || 'Client Name'}</strong></p>
                            <p style={{ margin: '2px 0' }}>{invoice.users_billing_details?.[0]?.address || 'Company Address'} {invoice.users_billing_details?.[0]?.city || 'City'} {invoice.users_billing_details?.[0]?.state || 'State'} {invoice.users_billing_details?.[0]?.country || 'Country'}</p>
                            <p style={{ margin: '2px 0', fontSize: '11px' }}>{invoice.users_billing_details?.[0]?.phone || 'Phone'} | {invoice.users_billing_details?.[0]?.email || 'client@email.com'}</p>
                        </div>
                    </div>

                    <table className="invoice-table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Description</th>
                                <th>Package</th>
                                <th>{invoice.tax_type_cgst === 'true' ? 'CGST %' : invoice.tax_type_sgst === 'true' ? 'SGST %' : invoice.tax_type_igst === 'true' ? 'IGST %' : invoice.tax_type_tax === 'true' ? 'Tax %' : '0'}</th>
                                <th>TAX Amount</th>
                                <th className="text-right">Amount</th>
                                <th className="text-right">Total Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoice.invoice_items && invoice.invoice_items.length > 0 ? (
                                invoice.invoice_items.map((item, index) => (
                                    <tr key={item.id || index}>
                                        <td>{index + 1}</td>
                                        <td>{item.packages[0]?.heading || 'Service Description'}</td>
                                        <td>{item?.packages[0]?.name || 'Standard'}</td>
                                        <td>{item.tax_rate_cgst || item.tax_rate_sgst || item.tax_rate_igst || item.tax_rate_tax || '0'}%</td>
                                        <td>₹{(parseFloat(item.tax_amount_cgst) || parseFloat(item.tax_amount_sgst) || parseFloat(item.tax_amount_igst) || parseFloat(item.tax_amount_tax) || 0).toFixed(2)}</td>
                                        <td className="text-right">₹{(parseFloat(item.price) || 0).toFixed(2)}</td>
                                        <td className="text-right">₹{(parseFloat(item.total_amount) || 0).toFixed(2)}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td>1</td>
                                    <td>{invoice.description || 'Service Description'}</td>
                                    <td>{invoice.package || 'Standard'}</td>
                                    <td>1</td>
                                    <td>0%</td>
                                    <td>₹0.00</td>
                                    <td className="text-right">₹{(parseFloat(invoice.amount) || 0).toFixed(2)}</td>
                                    <td className="text-right">₹{(parseFloat(invoice.amount) || 0).toFixed(2)}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    {/* Payment Summary - Compact Design */}
                    {invoice.invoice_payments && invoice.invoice_payments.length > 0 && (
                        <div style={{
                            marginTop: '15px',
                            padding: '10px',
                            backgroundColor: '#f8f9fa',
                            border: '1px solid #e9ecef',
                            borderRadius: '6px'
                        }}>
                            <h4 style={{
                                margin: '0 0 10px 0',
                                color: '#2980b9',
                                fontSize: '13px',
                                fontWeight: 'bold'
                            }}>
                                Payment History ({invoice.invoice_payments.length} payment{invoice.invoice_payments.length > 1 ? 's' : ''})
                            </h4>
                            <div style={{ display: 'grid', gap: '6px' }}>
                                {invoice.invoice_payments.map((payment, index) => (
                                    <div key={payment.id || index} style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        padding: '6px 8px',
                                        backgroundColor: 'white',
                                        border: '1px solid #dee2e6',
                                        borderRadius: '4px',
                                        fontSize: '11px'
                                    }}>
                                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                            <span style={{
                                                backgroundColor: '#28a745',
                                                color: 'white',
                                                borderRadius: '50%',
                                                width: '16px',
                                                height: '16px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontSize: '9px',
                                                fontWeight: 'bold'
                                            }}>
                                                {index + 1}
                                            </span>
                                            <div>
                                                <div style={{ fontWeight: 'bold', color: '#495057' }}>
                                                    {payment.transaction_id || 'N/A'}
                                                </div>
                                                <div style={{ color: '#6c757d', fontSize: '10px' }}>
                                                    {payment.payment_date} • {payment.payment_source}
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{ textAlign: 'right' }}>
                                            <div style={{ fontWeight: 'bold', color: '#28a745', fontSize: '12px' }}>
                                                ₹{parseFloat(payment.amount || 0).toFixed(2)}
                                            </div>
                                            {payment.reference_number && (
                                                <div style={{ color: '#6c757d', fontSize: '9px' }}>
                                                    Ref: {payment.reference_number}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div style={{
                                marginTop: '8px',
                                padding: '6px 8px',
                                backgroundColor: '#e8f5e8',
                                border: '1px solid #c3e6c3',
                                borderRadius: '4px',
                                fontSize: '11px',
                                fontWeight: 'bold',
                                color: '#155724',
                                textAlign: 'center'
                            }}>
                                Total Paid: ₹{invoice.invoice_payments.reduce((sum, payment) => sum + (parseFloat(payment.amount) || 0), 0).toFixed(2)}
                            </div>
                        </div>
                    )}

                    <div className='d-flex justify-content-between'>

                        <div style={{ marginTop: '30px', fontSize: '11px' }}>
                            <h4 style={{ margin: '0 0 0 0', color: '#2980b9' }}>Payment Terms:</h4>
                            <p style={{ margin: '2px 0' }}>• Payment due within 30 days of invoice date</p>
                            <p style={{ margin: '2px 0' }}>• Late payments may incur additional charges</p>
                            <p style={{ margin: '2px 0' }}>• For questions about this invoice, contact {settings.contact_email || 'support@company.com'}</p>
                            <h4 style={{ margin: '0 0 0 0', color: '#2980b9' }}>Payment Method:</h4>

                            <div className='d-flex justify-content-between'>
                                <p style={{ margin: '2px 0' }}>Bank Name:</p>
                                <p style={{ margin: '2px 0' }}>{bankAccountDetails?.bank_name || settings.bank_name || 'N/A'}</p>
                            </div>
                            <div className='d-flex justify-content-between'>
                                <p style={{ margin: '2px 0' }}>Account Number:</p>
                                <p style={{ margin: '2px 0' }}>{bankAccountDetails?.account_number || settings.bank_account_number || 'N/A'}</p>
                            </div>
                            <div className='d-flex justify-content-between'>
                                <p style={{ margin: '2px 0' }}>Account Holder:</p>
                                <p style={{ margin: '2px 0' }}>{bankAccountDetails?.name || settings.bank_account_holder || 'N/A'}</p>
                            </div>
                            <div className='d-flex justify-content-between'>
                                <p style={{ margin: '2px 0' }}>Account IFSC:</p>
                                <p style={{ margin: '2px 0' }}>{bankAccountDetails?.ifsc || settings.bank_ifsc_code || 'N/A'}</p>
                            </div>


                        </div>

                        <div className="invoice-totals " style={{ width: '40%' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                                <span>Subtotal:</span>
                                <span>₹{(parseFloat(invoice.amount) || 0).toFixed(2)}</span>
                            </div>
                            {/* <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                  <span>{invoice.tax_type_cgst === 'true' ? 'CGST :' : invoice.tax_type_sgst === 'true' ? 'SGST :' : invoice.tax_type_igst === 'true' ? 'IGST :' : invoice.tax_type_tax === 'true' ? 'Tax :' : '0'}</span>
                  <span>{(parseFloat(invoice.tax_rate_cgst) || parseFloat(invoice.tax_rate_sgst) || parseFloat(invoice.tax_rate_igst) || parseFloat(invoice.tax_rate_tax) || 0).toFixed(2)}%</span>
                </div> */}
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                                <span style={{ width: '75px', textAlign: 'left' }}>{invoice.tax_type_cgst === 'true' ? 'CGST :' : invoice.tax_type_sgst === 'true' ? 'SGST :' : invoice.tax_type_igst === 'true' ? 'IGST :' : invoice.tax_type_tax === 'true' ? 'Tax :' : '0'}</span>
                                <span>{(parseFloat(invoice.tax_rate_cgst) || parseFloat(invoice.tax_rate_sgst) || parseFloat(invoice.tax_rate_igst) || parseFloat(invoice.tax_rate_tax) || 0).toFixed(2)}%</span>
                                <span>₹{(parseFloat(invoice.tax_amount_cgst) || parseFloat(invoice.tax_amount_sgst) || parseFloat(invoice.tax_amount_igst) || parseFloat(invoice.tax_amount_tax) || 0).toFixed(2)}</span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                                <span style={{ width: '75px', textAlign: 'left' }}>Discount:</span>
                                <span>{(parseFloat(invoice.discount) || 0).toFixed(2)}%</span>
                                <span>₹{(parseFloat(invoice.discount_amount) || 0).toFixed(2)}</span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                                <span style={{ width: '75px', textAlign: 'left' }} >Process Fee :</span>
                                <span>{(parseFloat(invoice.processing_fee_percentage) || 2.5).toFixed(2)}%</span>
                                <span>₹{(parseFloat(invoice.processing_fee) || 0).toFixed(2)}</span>
                            </div>

                            {invoice.paid_amount > 0 && (
                                <>
                                    <hr style={{ margin: '10px 0' }} />
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                                        <span>Paid Amount:</span>
                                        <span>₹{(parseFloat(invoice.paid_amount) || 0).toFixed(2)}</span>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                                        <span>Total Amount:</span>
                                        <span>₹{(parseFloat(invoice.total_amount) || parseFloat(invoice.amount) || 0).toFixed(2)}</span>
                                    </div>
                                </>
                            )}

                            <hr style={{ margin: '10px 0' }} />
                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', fontWeight: 'bold' }}>
                                <span>{invoice.paid_amount > 0 ? 'Remaining Amount:' : 'Total Amount:'}</span>
                                <span>₹{(parseFloat(invoice.total_amount - invoice.paid_amount) || parseFloat(invoice.amount) || 0).toFixed(2)}</span>
                            </div>
                        </div>
                    </div>








                    {/* Footer always at bottom */}
                    <div className="" style={{
                        flexShrink: 0,
                        marginTop: 'auto',
                        borderTop: '1px solid #ddd',
                        paddingTop: '10px',
                        textAlign: 'center',
                        fontSize: '11px',
                        color: '#666'
                    }}>
                        <div className='d-flex column justify-content-end' style={{}}>
                            <div className='' style={{ marginTop: '10px', marginRight: '25px' }}>
                                <ImageShow url={settings.author_signature_url} width={80} />
                                <p className='mb-0 text-muted' style={{ textAlign: 'end' }}>Author Signature</p>
                            </div>
                        </div>
                        <div className='invoice-footer'>
                            <p style={{ marginBottom: '0', color: 'white' }}>Thank you for choosing {settings.site_name || 'our company'}!</p>
                            <p style={{ marginBottom: '0', color: 'white' }}>This is a computer-generated invoice.</p>
                        </div>
                    </div>
                </>
            ) : (
                <p>Invoice not available.</p>
            )}
        </div>
    );
}


export const callOpenAISeo = async (url) => {
    try {
        const prompt = `
  You are an SEO assistant. Visit the given URL and extract structured SEO metadata. 
  Return only valid JSON with these fields:
  
  {
    "title": "",
    "description": "",
    "keywords": "",
    "og_title": "",
    "og_description": "",
    "og_image": "",
    "twitter_title": "",
    "twitter_description": "",
    "twitter_image": "",
    "cronical_title": "",
    "cronical_description": "",
    "cronical_keywords": "",
    "cronical_image": "",
    "cronical_url": "",
    "cronical_type": "",
    "cronical_site_name": ""
  }
  
  URL: ${url}
  `;

        const response = await fetch("https://api.openai.com/v1/chat/completions", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`, // put your key in .env
            },
            body: JSON.stringify({
                model: "gpt-4o-mini",
                messages: [{ role: "user", content: prompt }],
                temperature: 0,
            }),
        });

        const data = await response.json();
        console.log("seodata getseodata callOpenAISeo data", data);
        const text = data?.choices?.[0]?.message?.content || "{}";
        console.log("seodata getseodata callOpenAISeo text", text);

        return JSON.parse(text);
    } catch (err) {
        console.error("OpenAI SEO extraction failed", err);
        return {};
    }
};



// ✅ Main function without gethtml
export const updateseodata = async (pagePath, url) => {
    if (!url) return null;

    console.log("seodata getseodata updateseodata pagePath", pagePath);

    // Replace localhost with meddylist
    const updatedUrl = url.replace("http://localhost:3000", "https://tech2day.co.in");
    console.log("seodata getseodata Updated URL:", updatedUrl);

    // Step 1: Extract SEO using OpenAI API
    let localSeo = {};
    try {
        const openaiSeo = await callOpenAISeo(updatedUrl);

        console.log("seodata getseodata updateseodata: OpenAI SEO", openaiSeo);

        if (openaiSeo && typeof openaiSeo === "object") {
            localSeo = openaiSeo;

            // Step 2: Insert into seo_pages
            const tableSchema = "";
            const tableName = "seo_pages";
            const data = {
                path: pagePath,
                title: localSeo.title || "",
                description: localSeo.description || "",
                type: "page",
            };
            const conditions = { path: pagePath };

            const createseopage = await oneKlicks.create(tableSchema, tableName, data, conditions).catch((e) => {
                console.error("seodata getseodata updateseodata: create seo_pages failed", e);
                return { success: false };
            });
            console.log("handleSavePageSeo createseopage", createseopage);

            // Step 3: Insert into seo_data if seo_pages success
            if (createseopage.success) {
                const pageSeo = {
                    title: localSeo.title || "",
                    description: localSeo.description || "",
                    keywords: Array.isArray(localSeo.keywords)
                        ? localSeo.keywords.join(", ")
                        : localSeo.keywords || "",
                    og_title: localSeo.og_title || "",
                    og_description: localSeo.og_description || "",
                    og_image: localSeo.og_image || "",
                    twitter_title: localSeo.twitter_title || "",
                    twitter_description: localSeo.twitter_description || "",
                    twitter_image: localSeo.twitter_image || "",
                    page_id: createseopage.insertedData && createseopage.insertedData.id,
                    page_path: pagePath,
                    page_title: localSeo.title || "",
                };

                const seoData = await oneKlicks.create(tableSchema, "seo_data", pageSeo, {}).catch((e) => {
                    console.error("seodata getseodata updateseodata: create seo_data failed", e);
                    return { success: false };
                });

                if (seoData.success) {
                    console.log("seodata getseodata updateseodata: SEO Page created successfully");
                } else {
                    console.error("seodata getseodata updateseodata: Failed to create SEO Data");
                }
            } else {
                console.error("seodata getseodata updateseodata: Failed to create SEO Page");
            }
        } else {
            console.log("seodata getseodata updateseodata: OpenAI SEO failed", openaiSeo);
            return null;
        }
    } catch (e) {
        console.error("seodata getseodata updateseodata: OpenAI SEO failed", e);
        return null;
    }



    return updatedUrl;
};



export const getroles = async (id = null, menu = "") => {
    try {
        const tableSchema = '';
        const tableName = 'roles';
        const conditions = { id: id };
        const orderBy = 'id DESC';
        const search = {};
        const pagination = {};
        const margedata = {};
        const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
        console.log("response getroles :", response);
        return response;
    } catch (error) {
        console.error('response getroles :', error);
        return null;
    }
}

export const getpermissions = async (id = null, permissionName = null) => {
    try {
        const currentUser = await getuserdata('full');
        const tableSchema = '';
        const tableName = 'roles';
        const conditions = { id: id || currentUser.role };
        const orderBy = 'id DESC';
        const search = {};
        const pagination = {};
        const margedata = {};
        if (currentUser.user_type === "administrator") {
            return "administrator";
        }
        const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
        console.log("getpermissions apiservice response getpermissions :", response.data[0].permissions);
        console.log("getpermissions apiservice currentUser.user_type :", currentUser.user_type);

        if (permissionName) {
            return response.data[0].permissions.some(permission => permission.value === permissionName);
        } else {
            let permissionjson = [];

            if (typeof response.data[0].permissions === 'string') {
                permissionjson = JSON.parse(response.data[0].permissions);
            } else {
                permissionjson = response.data[0].permissions;
            }

            console.log('getpermissions apiservice permissionjson buildMenu json:', permissionjson);
            return permissionjson;
        }
    } catch (error) {
        console.error('getpermissions apiservice response getpermissions :', error);
        return null;
    }
}


/**
 * Check if a user has a specific permission
 * @param {string|number} userId - The user ID to check permissions for
 * @param {string} permissionName - The permission name to check (e.g., 'view_dashboard', 'manage_appointments')
 * @returns {Promise<boolean>} - Returns true if user has the permission, false otherwise
 */
export const checkUserPermission = async (userId, permissionName) => {
    try {
        // Get user data to find their role
        const userData = await getuserdata("full", userId);

        if (!userData || !userData.role) {
            console.log("User not found or has no role assigned");
            return false;
        }

        // Get role data using the role ID from user data
        const roleResponse = await getroles(userData.role);

        if (!roleResponse || !roleResponse.success || !roleResponse.data || roleResponse.data.length === 0) {
            console.log("Role not found or no role data available");
            return false;
        }

        const roleData = roleResponse.data[0];

        // Parse permissions from JSON string
        let permissions = [];
        try {
            if (typeof roleData.permissions === 'string') {
                permissions = JSON.parse(roleData.permissions);
            } else if (Array.isArray(roleData.permissions)) {
                permissions = roleData.permissions;
            }
        } catch (parseError) {
            console.error('Error parsing permissions:', parseError);
            return false;
        }

        // Check if the permission exists in the user's role
        const hasPermission = permissions.some(permission => {
            // Handle both object format with 'value' property and string format
            const permissionValue = typeof permission === 'string' ? permission : permission.value;
            return permissionValue === permissionName;
        });

        console.log(`User ${userId} permission check for '${permissionName}':`, hasPermission);
        return hasPermission;

    } catch (error) {
        console.error('Error checking user permission:', error);
        return false;
    }
}

/**
 * Check if the current logged-in user has a specific permission
 * @param {string} permissionName - The permission name to check (e.g., 'view_dashboard', 'manage_appointments')
 * @returns {Promise<boolean>} - Returns true if user has the permission, false otherwise
 */
export const checkCurrentUserPermission = async (permissionName) => {
    try {
        // Get current user ID from localStorage
        const userData = localStorage.getItem("userData");
        let userId = null;

        if (userData) {
            const userDataObject = JSON.parse(userData);
            userId = userDataObject.id;
        } else {
            userId = localStorage.getItem('userid');
        }

        if (!userId) {
            console.log("No user ID found in localStorage");
            return false;
        }

        return await checkUserPermission(userId, permissionName);

    } catch (error) {
        console.error('Error checking current user permission:', error);
        return false;
    }
}

export const getuserdata = async (datatype, id = null) => {
    try {
        // Validate environment variable
        const tableSchema = "";

        // Validate datatype
        if (!datatype) {
            console.error('Datatype is required.');
            return null;
        }

        // Get user ID - use passed id if provided, otherwise get from localStorage
        let userData = null;
        let tableName = null;
        let userId = id;
        if (userId === null) {
            // Check userData, then user, then presentuser to support different login flows
            userData = localStorage.getItem("userData") || localStorage.getItem("user") || localStorage.getItem("presentuser");

            if (userData) {
                try {
                    const userDataObject = JSON.parse(userData);
                    userId = userDataObject.id;
                    // Determine table name based on user_type
                    switch (userDataObject.user_type) {
                        case "pharmacy":
                            tableName = "pharmacies";
                            break;
                        case "blood_bank":
                            // Reverting to singular 'blood_bank' as primary based on loginapi success.
                            // Plural 'blood_banks' caused 500 Error.
                            tableName = "blood_bank";
                            break;
                        case "diagnostic":
                            tableName = "diagnostics";
                            break;
                        case "ambulance":
                            tableName = "ambulances";
                            break;
                        default:
                            tableName = "users";
                    }
                } catch (e) {
                    console.error("Error parsing user data in getuserdata:", e);
                }
            }

            if (!userId) {
                userId = localStorage.getItem('userid');
                if (!tableName) tableName = "users";
            }
        }

        if (!userId) {
            console.error('id not found. Please log in again.');
            return null;
        }


        // Fetch user details from the database
        const conditionsUsers = { id: userId };
        let userdata = await oneKlicks.read(tableSchema, tableName, conditionsUsers, "", "");

        // FALLBACK LOGIC: If user not found in the expected table, try ALL tables to find the ID
        if (!userdata.success || !userdata.data || userdata.data.length === 0) {
            console.warn(`getuserdata: User ${userId} not found in '${tableName}'. Trying fallback tables with multiple ID columns.`);

            // Removed 'users' from fallback list as per user request ("not from users table")
            // UPDATE: Re-adding 'users' as LAST RESORT because if the user is not found in specialized tables 
            // (e.g. migration pending), we must return the basic user record to avoid "ID: null" / empty sidebar.
            let tablesToCheck = ["pharmacies", "blood_bank", "blood_banks", "diagnostics", "ambulances", "hospitals", "users"];

            // STRICT FILTERING: If we know the user_type (via tableName), ONLY search relevant tables.
            // This prevents ID collisions (e.g. Pharmacy ID 1 vs Blood Bank ID 1).
            // UPDATE: Added 'users' as last option to prevent lockout.
            if (tableName === "blood_banks" || tableName === "blood_bank") {
                tablesToCheck = ["blood_bank", "blood_banks", "users"];
            } else if (tableName === "pharmacies") {
                tablesToCheck = ["pharmacies", "users"];
            } else if (tableName === "diagnostics") {
                tablesToCheck = ["diagnostics", "users"];
            } else if (tableName === "ambulances") {
                tablesToCheck = ["ambulances", "users"];
            }

            for (const table of tablesToCheck) {
                try {
                    // Determine potential ID columns for this table
                    const idColumns = ["id"];
                    if (table !== "users") {
                        // For specialized tables, often the stored ID in localStorage is the 'user_id' (FK) from users table
                        idColumns.push("user_id");

                        if (table === "blood_bank" || table === "blood_banks") idColumns.push("blood_bank_id");
                        else if (table === "diagnostics") idColumns.push("diagnostic_id", "diagnostics_id");
                        else if (table === "pharmacies") idColumns.push("pharmacy_id");
                        else if (table === "ambulances") idColumns.push("ambulance_id");
                    }

                    for (const col of idColumns) {
                        const dynamicConditions = { [col]: userId };
                        const fallbackCheck = await oneKlicks.read(tableSchema, table, dynamicConditions, "", "");

                        if (fallbackCheck.success && fallbackCheck.data && fallbackCheck.data.length > 0) {
                            console.log(`getuserdata: User found in fallback table '${table}' using column '${col}'`);
                            userdata = fallbackCheck;
                            tableName = table;

                            // normalize ID if needed
                            if (userdata.data && userdata.data[0] && !userdata.data[0].id) {
                                userdata.data[0].id = userdata.data[0][col];
                            }
                            break;
                        }
                    }
                    if (userdata && userdata.success && userdata.data && userdata.data.length > 0) break;
                } catch (fallbackError) {
                    console.warn(`getuserdata: Error checking table '${table}':`, fallbackError);
                    // Continue to next table
                }
            }
        }

        if (!userdata.success) {
            console.error('Failed to fetch user data or no user data found.');
            return null;
        }

        if (datatype === "full") {
            debugLog('userdata full', userdata);

            if (!userdata.data || userdata.data.length === 0) {
                console.warn("getuserdata: No data array returned.");
                return null;
            }

            // Handle display_name based on table
            if (tableName === "pharmacies" || tableName === "blood_bank" || tableName === "blood_banks" || tableName === "diagnostics" || tableName === "ambulances") {
                if (userdata.data[0]) {
                    userdata.data[0].display_name = userdata.data[0].name || userdata.data[0].display_name;
                }
            }
            // Handle user_type based on table
            if (tableName === "pharmacies") {
                userdata.data[0].user_type = "pharmacy";
            } else if (tableName === "blood_bank" || tableName === "blood_banks") {
                userdata.data[0].user_type = "blood_bank";
            } else if (tableName === "diagnostics") {
                userdata.data[0].user_type = "diagnostic";
            } else if (tableName === "ambulances") {
                userdata.data[0].user_type = "ambulance";
            }
            return userdata.data[0];
        } else if (datatype === "display_name") {
            if (tableName === "pharmacies" || tableName === "blood_bank" || tableName === "diagnostics" || tableName === "ambulances") {
                return userdata.data[0].name || userdata.data[0].display_name;
            }
            return userdata.data[0].display_name;
        } else if (datatype === "user_type") {
            if (tableName === "pharmacies") return "pharmacy";
            if (tableName === "blood_bank") return "blood_bank";
            if (tableName === "diagnostics") return "diagnostic";
            if (tableName === "ambulances") return "ambulance";
            return userdata.data[0].user_type;
        }

        // Extract user details
        const useralldata = userdata.data[0] || {};

        console.log('useralldata', useralldata);

        if (!useralldata.id) {
            console.error('Invalid user data. Please log in again.');
            return null;
        }

        // Validate and return the requested data
        if (datatype in useralldata) {
            return useralldata[datatype];
        } else {
            console.warn(`Datatype "${datatype}" not found in user data.`);
            return null;
        }
    } catch (error) {
        console.error('Error fetching user data:', error);
        return null;
    }
};


export const getsettingsdata = async (key) => {
    try {
        // Validate environment variable
        const tableSchema = "";



        // Fetch user details from the database
        const conditionsUsers = { setting_key_name: key };
        const userdata = await oneKlicks.read(tableSchema, "site_settings", conditionsUsers, "", "");

        if (!userdata.success) {
            console.error('Failed to fetch user data or no user data found.');
            return null;
        }

        return userdata.data[0].value;
    } catch (error) {
        console.error('Error fetching user data:', error);
        return null;
    }
};

export const getDoctor = async (doctorData) => {
    // doctorData should include: name, specialty, location, etc.
    const prompt = `
                        Given the following doctor information:
                        ${JSON.stringify(doctorData, null, 2)}

                        Return a JSON object with:
                        - "specialities": an array of specialities under this doctor/clinic.
                        - "services": an array of common services offered.
                        - "prices": an array of objects with "service" and "cost" (in INR).

                        Example format:
                        {
                        "specialities": ["Cardiology", "Internal Medicine"],
                        "services": ["ECG", "Consultation", "Blood Pressure Check"],
                        "prices": [
                            {"service": "ECG", "cost": "₹500"},
                            {"service": "Consultation", "cost": "₹800"}
                        ]
                        }
                    `;

    const response = await fetch('https://api.openai.com/v1/chat/completions', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer YOUR_OPENAI_API_KEY` // Replace with your key
        },
        body: JSON.stringify({
            model: 'gpt-3.5-turbo',
            messages: [{ role: 'user', content: prompt }],
            max_tokens: 400
        })
    });

    const data = await response.json();
    // Extract the JSON from the response
    try {
        const jsonStart = data.choices[0].message.content.indexOf('{');
        const jsonString = data.choices[0].message.content.slice(jsonStart);
        return JSON.parse(jsonString);
    } catch (e) {
        // fallback: return the raw text if parsing fails
        return { error: "Failed to parse AI response", raw: data.choices[0].message.content };
    }
};

export const encryptId = (id) => {
    // Simple encryption: convert to base64 and add some salt
    const salt = 'meddylist';
    const encrypted = btoa(id + salt);
    console.log('encryptId - original:', id, 'encrypted:', encrypted);
    return encrypted;
};

export const decryptId = (encryptedId) => {
    console.log('decryptId - encryptedId:', encryptedId);
    const salt = 'meddylist';
    try {
        const decoded = atob(encryptedId);
        console.log('decryptId - After atob:', decoded);
        const decrypted = decoded.replace(salt, '');
        console.log('decryptId - After salt removal:', decrypted);
        return decrypted;
    } catch (error) {
        console.error('Error decrypting ID:', error);
        return null;
    }
};

// Test function to debug encoding/decoding
export const testEncoding = (id) => {
    console.log('=== Testing encoding/decoding ===');
    console.log('Original ID:', id);
    const encrypted = encryptId(id);
    console.log('Encrypted:', encrypted);
    const decrypted = decryptId(encrypted);
    console.log('Decrypted:', decrypted);
    console.log('Match:', id === decrypted);
    console.log('=== End test ===');
};

export const getdoctorspecialities = async (id) => {
    if (!id) {
        throw new Error('Doctor ID is required');
    }

    try {
        const tableSchema = "";
        const tableName = "doctor_specialities";
        const conditions = {
            doctor_id: id
        };
        const orderBy = "id DESC";
        const search = "";
        const pagination = "";
        const margedata = [
            {
                target_table: "specialities",
                target_column: "id",
                target_value: "speciality_id",
                target_label: "speciality_name"
            },
            {
                target_table: "services",
                target_column: "id",
                target_value: "service_id",
                target_label: "service_name"
            }
        ];

        const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);

        console.log("getdoctorspecialities response", response);
        if (response.data.length > 0) {
            return response.data;
        } else {
            return [];
        }

    } catch (error) {
        console.error("Error in getdoctorspecialities:", error);
        return {
            success: false,
            error: error.message || 'Failed to fetch doctor specialities',
            specialities: [],
            services: []
        };
    }
};

export const getdoctoreducation = async (id) => {
    const tableSchema = "";
    const tableName = "doctor_experience_education";
    const conditions = {
        user_id: id
    };
    const response = await oneKlicks.read(tableSchema, tableName, conditions, "", "", "", "");

    if (response.status === 200) {
        console.log("response", response.data[0].educations);

        if (response.success) {
            console.log("response.data[0].education", response.data[0].educations);
            return response.data[0].educations;
        } else {
            return [];
        }
    } else {
        return [];
    }
}

export const getServiceId = async (id) => {
    const tableSchema = "";
    const tableName = "services";
    const conditions = {
        old_id: id
    };
    const response = await oneKlicks.read(tableSchema, tableName, conditions, "", "", "", "");
    return response.data[0].id;
}

export const addToWishlist = async (doctorId) => {
    const user_id = await getuserdata('id');
    if (user_id) {
        const tableSchema = '';
        const tableName = 'wishlist';

        // Check if already in wishlist manually to avoid composite key issues in create
        const existing = await oneKlicks.read(tableSchema, tableName, {
            user_id: user_id,
            doctor_id: doctorId
        });

        if (existing.success && existing.data.length > 0) {
            toast.error("Doctor already in wishlist");
            return;
        }

        const data = {
            user_id: user_id,
            doctor_id: doctorId
        };

        const responce = await oneKlicks.create(tableSchema, tableName, data, {});
        if (responce.success === true) {
            toast.success("Doctor added to wishlist");
        } else {
            toast.error("Failed to add to wishlist");
        }
    } else {
        toast.error("Please login to add to wishlist");
    }
}

export const removeFromWishlist = async (doctorId) => {
    const user_id = await getuserdata('id');
    if (user_id) {
        const tableSchema = '';
        const tableName = 'wishlist';
        const data = {
            user_id: user_id,
            doctor_id: doctorId
        };
        const conditions = {
            user_id: user_id,
            doctor_id: doctorId
        };
        const responce = await oneKlicks.delete(tableSchema, tableName, conditions);
        if (responce.success === true) {
            toast.success("Doctor removed from wishlist");
        } else {
            toast.error("Doctor not in wishlist");
        }
    } else {
        toast.error("Please login to add to wishlist");
    }
}

export const getWishlist = async () => {
    const user_id = await getuserdata('id');
    if (user_id) {
        const tableSchema = '';
        const tableName = 'wishlist';
        const conditions = {
            user_id: user_id
        };
        const orderBy = "id DESC";
        const search = {};
        const pagination = {};
        const margedata = [
            {
                target_table: 'users',
                target_column: 'id',
                target_value: 'doctor_id',
                target_label: 'doctor',
                margedata: [
                    {
                        target_table: "doctor_specialities",
                        target_column: "doctor_id",
                        target_value: "id",
                        target_label: "doctor_specialities",
                        margedata: [
                            {
                                target_table: "specialities",
                                target_column: "id",
                                target_value: "speciality_id",
                                target_label: "specialities"
                            }
                        ]
                    }
                ]
            }
        ];
        const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
        if (response.success === true && response.data.length > 0) {
            return response.data;
        } else {
            return [];
        }
    } else {
        return [];
    }
}

export const getBanners = async (condition, orderB, searc, paginatio, margedat, rangtype) => {
    const location = await Getlocation();
    const tableSchema = '';
    const tableName = 'banners';
    const conditions = condition;
    const orderBy = orderB;
    const search = searc;
    const pagination = paginatio;
    const margedata = margedat;
    const range = rangtype === true ? {
        latitude: location.latitude,
        longitude: location.longitude,
        radius: 50, // in kilometers
        target_latitude: "latitude",
        target_longitude: "longitude"
    } : {};

    const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata, range);
    return response;
}


export const loginapi = async (email, password, type) => {
    try {
        const hashedPassword = CryptoJS.SHA256(password).toString();
        const tableSchema = "";

        const conditions = {
            "email": email,
            "pass": type === true ? password : hashedPassword,
        };
        const orderBy = "id DESC";
        const search = null;
        const pagination = null;
        const margedata = null;

        // Check tables in priority order: Specialized FIRST, Users LAST
        // This ensures we find the specific role user (e.g. Blood Bank ID 1) before the generic user (ID 5807)
        const tablesToCheck = ["pharmacies", "blood_bank", "diagnostics", "users"];

        let lastResponse = null;

        for (const tableName of tablesToCheck) {
            try {
                // 1. Check with primary condition (Hashed or Direct)
                let response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);

                // 2. Fallback: If not found and using regular login (type!=true), try Plain Text Password
                if ((!response.success || !response.data || response.data.length === 0) && type !== true) {
                    const plainConditions = { ...conditions, pass: password };
                    response = await oneKlicks.read(tableSchema, tableName, plainConditions, orderBy, search, pagination, margedata);
                }

                if (response.success && response.data && response.data.length > 0) {
                    console.log(`loginapi: User found in ${tableName}:`, response);

                    // Inject user_type for specialized tables
                    if (tableName === "pharmacies") response.data[0].user_type = "pharmacy";
                    else if (tableName === "blood_bank") response.data[0].user_type = "blood_bank";
                    else if (tableName === "diagnostics") response.data[0].user_type = "diagnostic";

                    const { token, user } = response.data[0];
                    localStorage.setItem("token", token);
                    localStorage.setItem("user", JSON.stringify(user));

                    return response;
                }
            } catch (tableError) {
                console.log(`loginapi: Error checking ${tableName}:`, tableError);
            }
        }

        // If no user found in any table, return the last response (likely 'users' failure) or a generic failure
        return lastResponse || { success: false, message: "User not found" };

    } catch (error) {
        console.error("Error logging in:", error);
        throw error;
    }
}

export const registerapi = async (username, email, first_name, last_name, display_name, address, password, verify_password, user_type, termsconditions, latitude, longitude, phoneNumber, add_by = null) => {

    console.log("Register API called with:", username, email, first_name, last_name, display_name, address, password, verify_password, user_type, termsconditions, latitude, longitude);
    const hashedPassword = CryptoJS.SHA256(password).toString();
    const tableSchema = "";

    // Determine table based on user_type
    let tableName = "users";
    if (user_type === "blood_bank") tableName = "blood_bank";
    else if (user_type === "pharmacy") tableName = "pharmacies";
    else if (user_type === "diagnostic") tableName = "diagnostics";
    else if (user_type === "ambulance") tableName = "ambulances";

    const conditions = {
        email: email,
    };
    // Base data common to all tables
    const data = {
        email: email,
        first_name: first_name,
        last_name: last_name,
        display_name: display_name,
        address: address,
        pass: hashedPassword,
        user_type: user_type,
        phone: phoneNumber,
        add_by: add_by,
    };

    // Table-specific field mapping
    if (tableName === "users") {
        data.login = username;
        data.nicename = username;
        data.latitude = latitude;
        data.longitude = longitude;
        data.verify_password = verify_password;
        data.termsconditions = termsconditions;
    } else {
        // Specialized tables (blood_bank, diagnostics, ambulances, pharmacies)
        // Schema uses 'username', 'lat', 'lng' instead of 'login', 'latitude', 'longitude'
        data.username = username;
        data.lat = latitude;
        data.lng = longitude;
        data.status = "active"; // Default status for new registrations
    }
    const response = await oneKlicks.create(tableSchema, tableName, data, conditions);
    console.log("Response from create:", response);

    return response;

}

export const getBalance = async () => {
    const tableSchema = "";
    const tableName = "balance";
    const conditions = {};
    const orderBy = "id DESC";
    const search = {};
    const pagination = {};
    const margedata = [];
    const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
    if (!response.success) {
        throw new Error('Failed to get balance');
    }
    return response.data[0].amount;
}

export const updateuserBalance = async (balance, account_id) => {
    debugLog('balance', balance);
    debugLog('account_id', account_id);
    const tableSchema = "";
    const tableName = "balance";
    const conditions = {
        account_id: account_id
    };
    const orderBy = "id DESC";
    const search = {};
    const pagination = {};
    const margedata = [];
    const data = {
        amount: balance
    };
    const response = await oneKlicks.update(tableSchema, tableName, data, conditions);
    debugLog('response', response);
    if (!response.success) {
        throw new Error('Failed to update balance');
    }
    return response;
}

export const getDoctorList = async (show_users, profile_id, page_number, listing_type, latitude, longitude, radius, user_id, keyword, location, specialities, services, searchby, orderby, add_by, add_by_date) => {
    try {
        const response = await axios.post(`${apiUrl}listing/web_get_doctors`, {
            show_users: show_users,
            profile_id: profile_id,
            page_number: page_number,
            listing_type: listing_type,
            latitude: latitude,
            longitude: longitude,
            radius: radius,
            user_id: user_id,
            keyword: keyword,
            location: location,
            specialities: specialities,
            services: services,
            orderby: orderby,
            searchby: searchby,
            add_by: add_by,
            add_by_date: add_by_date,
        });

        if (response.status === 200) {
            return response.data;
        } else {
            return response.data;
        }
    } catch (error) {
        console.error("Error fetching doctor list:", error);
        throw error;
    }
}

export const getspecialities = async () => {
    try {
        const response = await axios.post(`${apiUrllocal}specialities/get-specialities`, {
            "parent": ""
        });

        if (response.status === 200) {
            return response.data;
        } else {
            return response.data;
        }
    } catch (error) {
        console.error("Error fetching specialities:", error);
        throw error;
    }
}

export const getservices = async () => {
    try {
        const response = await axios.post(`${apiUrllocal}specialities/get-services`, {
            "parent": ""
        });

        if (response.status === 200) {
            return response.data;
        } else {
            return response.data;
        }
    } catch (error) {
        console.error("Error fetching specialities:", error);
        throw error;
    }
}

